var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVmonadLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 128 122",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,122) scale(0.1,-0.1)",
    fill: "currentColor",
    stroke: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318 1193 c-15 -16 -92 -144 -172 -286 -122 -216 -146 -265 -146 -299 0 -33 26 -91 131 -297 73 -141 143 -268 157 -284 26 -27 26 -27 352 -27 327 0 327 0 349 24 13 13 83 140 157 282 114 218 134 264 134 302 0 39 -19 79 -140 301 -78 141 -154 268 -171 284 -29 27 -29 27 -327 27 -298 0 -298 0 -324 -27z m592 -23 c32 -9 42 -22 108 -142 39 -73 90 -164 111 -203 39 -70 39 -70 -294 -65 -183 3 -335 7 -338 10 -3 3 -39 74 -81 157 -83 167 -93 210 -54 237 19 13 62 16 268 16 135 0 261 -5 280 -10z m-300 -778 c0 -5 -38 -78 -84 -163 -69 -128 -90 -157 -120 -174 -63 -35 -74 -23 -225 270 -74 142 -134 270 -134 284 0 22 68 147 220 409 25 44 25 44 184 -287 87 -181 159 -334 159 -339z m130 226 c-28 -51 -61 -112 -72 -135 -21 -41 -21 -41 -85 89 -34 71 -63 132 -63 134 0 2 61 4 135 4 136 0 136 0 85 -92z m443 70 c12 -6 27 -18 34 -27 32 -42 27 -57 -109 -319 -73 -141 -142 -267 -155 -280 -22 -22 -27 -22 -247 -22 -224 0 -224 0 -44 330 180 330 180 330 340 330 102 0 167 -4 181 -12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVmonadLogo);
export default __webpack_public_path__ + "static/media/vmonad-logo.ca9b25d142976c2f5d1a29e4041995d7.svg";
export { ForwardRef as ReactComponent };